// extracted by mini-css-extract-plugin
export default {"container":"vcXJfPO fVdHxMU","link":"R2BDZ6J TYb4J9A","hidden":"Gt0QBeS","body":"m8VFiIf","navigation":"myUaKmo","appDownloadLink":"eWFSkWC ZHWKoMf leavesden3"};